import { FeedbackButton } from '../Feedback';

export function AdaptiveContentFeedbackButton() {
    return (
        <FeedbackButton
            kind="blank"
            size="medium"
            flagKey="ADAPTIVE_CONTENT"
            feedbackDialogTitle="Tell us what you think and help us improve Adaptive content"
        />
    );
}
